import { Component, Injector, OnInit, ContentChildren, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { UserType } from 'src/app/core/enums/user-type.enum';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { NotificationSubScriptionService } from 'src/app/core/services/notification-sub-scription.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { deepCopy, getCustomerByPermission, getFacilityByPermission, getForwarderByPermission, getTenantByPermission, getOrgIdByPermission } from 'src/app/core/utils/common-functions';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';

@Component({
  selector: 'laas-notification-subscribtion',
  templateUrl: './notification-subscribtion.component.html',
  styleUrls: ['./notification-subscribtion.component.scss']
})
export class NotificationSubscribtionComponent extends SessionBaseComponent implements OnInit {
  readonly permissionCode = PermissionConstants.ViewSubscription;
  currentLang: string = this.laasSetting.language;
  @Input()isShowAddSubscribtion : boolean = true;
  @Input()isShowEditColumn : boolean = true;

  notifyForm!: FormGroup;
  submitted = false;
  infoType: number;
  subscriber: string;
  userType: string;
  email: string;
  eventTypeOptions: any[];
  selectedEventType: string[];
  tenantOptions: any[];
  selectedTenant: string[];
  facilityOptions: any[];
  selectedFacility: string[];
  forwarderOptions: any[];
  selectedForwarder: string[];

  cutomerOptions: any[];
  selectedCustomer: string[];
  orgIdOptions: any[];
  orgIdOptionsBySelectedTenant: any[];
  selectedOrgId: string[];
  selectedFileType: string;

  subscribeResults: any;
  isLoading: boolean;
  isByOwner: boolean;
  isSplitFile: boolean;
  isDisabledPersonalSubscription: boolean;
  isDisabledPersonalSubscriptionForEdit: boolean;
  isShowEditDialog: boolean;
  modalConfig: any;
  editObject: any;

  isShowAttachFile: boolean;
  isShowTenant: boolean;
  isShowFacility: boolean;
  isShowForwarder: boolean;
  isShowCustomer: boolean;
  isShowOrgId: boolean;
  editIsShowAttachFile = true;
  editIsShowTenant : boolean;
  editIsShowFacility : boolean;
  editIsShowForwarder : boolean;
  editIsShowCustomer : boolean;
  editIsShowOrgId : boolean;

  isOpenFilter: boolean;
  formParam: any;
  filterEventTypeOptions:any[];
  filterTenantOptions:any[];
  filterFacilityOptions:any[];
  filterForwarderOptions:any[];
  filterCutomerOptions:any[];
  filterOrgIdOptions: any[];
  fileTypeOptions: any[];
  isByOwnerOptions: any[];

  subscribableEventValues: any[];

  //translate label : choose
  transLabel: any;

  tenantOptionsForEdit: any[];
  facilityOptionsForEdit: any[];
  forwarderOptionsForEdit: any[];
  cutomerOptionsForEdit: any[];
  orgIdOptionsForEdit: any[];
  isForwarderDisabled: boolean = false;
  orginForwarderOptions: any[];
  orginForwarderOptionsForEdit: any[];



  constructor(
    injector: Injector,
    private notificationSubScriptionService: NotificationSubScriptionService,
    private dropdownOptionsService: DropdownOptionsService,
    private formBuilder: FormBuilder,
    private translate: TranslateService,
    private dropdownOptionService: DropdownOptionsService,
  ) {
    super(injector);
    this.isByOwner = false;
    this.isSplitFile = false;
    this.isDisabledPersonalSubscription = true;
    this.isDisabledPersonalSubscriptionForEdit = true;
    this.isLoading = false;
    this.isShowEditDialog = false;
    this.isOpenFilter = false;
    this.isShowAttachFile = true;
    this.isShowTenant = true;
    this.isShowFacility = true;
    this.isShowForwarder = true;
    this.isShowCustomer = true;
    this.isShowOrgId = true;
    this.editIsShowAttachFile = true;
    this.editIsShowTenant = true;
    this.editIsShowFacility = true;
    this.editIsShowForwarder = true;
    this.editIsShowCustomer = true;
    this.editIsShowOrgId = true;
    this.eventTypeOptions = [];
    this.tenantOptions = [];
    this.facilityOptions = [];
    this.forwarderOptions = [];
    this.cutomerOptions = [];
    this.orgIdOptions = [];
    this.orgIdOptionsBySelectedTenant = [];
    this.filterEventTypeOptions = [];
    this.filterFacilityOptions = [];
    this.filterCutomerOptions = [];
    this.filterForwarderOptions = [];
    this.filterTenantOptions = [];
    this.filterOrgIdOptions = [];
    this.tenantOptionsForEdit = [];
    this.facilityOptionsForEdit = [];
    this.forwarderOptionsForEdit = [];
    this.cutomerOptionsForEdit = [];
    this.orgIdOptionsForEdit = [];
    this.fileTypeOptions = [];
    this.isByOwnerOptions = [];
    this.editObject = {
      sendingTarget: "",
      tenantCode: "",
      facilityCode: "",
      facilityName: "",
      forwarderCode: "",
      forwarderName: "",
      customerCode: "",
      customerName: "",
      orgId: "",
      orgName: "",
      isActivated: 0,
      notifyEventName: "",
      notifyEventSeqNo: "",
      sendingMethod: "",
      isChecked: false,
      isByOwner: false,
      isCheckedByOwner: false,
      fileTypeFlag: "N"
    };
    this.modalConfig = {
      modal: true,
      draggable: false
    };
    this.formParam = {
      eventType: "",
      tenant: "",
      facility: "",
      forwarder: "",
      consigneeKey: "",
      subscriberId: "",
      orgId: "",
      language: "",
      selectedFileType: undefined
    };
    this.infoType = 0;
    this.subscriber = "";
    this.email = "";
    this.userType = "";
    this.selectedFileType = "";

    //transkate "choose" words
    this.transLabel = ''
    this.translate.onLangChange.subscribe((e: Event) => {
      this.translationLabel();
    });
    this.translationLabel();

    this.selectedEventType = [];
    this.selectedTenant = [];
    this.selectedFacility = [];
    this.selectedForwarder = [];
    this.selectedCustomer = [];
    this.selectedOrgId = [];
    this.subscribeResults = [];
    this.notifyForm = this.formBuilder.group({
      eventType: [[], Validators.required]
    });

    this.subscribableEventValues = [];
    this.orginForwarderOptions = [];
    this.orginForwarderOptionsForEdit = [];
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    this.email = this.userProfile.email;
    this.subscriber = this.userProfile.loginAccount;
    this.formParam.subscriberId = [this.userProfile.loginAccount];
    this.userType = this.userProfile.userType;
    this.searchNotifyEvent();

    this.notificationSubScriptionService.getNotifyEventOptions().subscribe({
      next: result => {
        this.eventTypeOptions = deepCopy(result);
        this.filterEventTypeOptions = deepCopy(result);
        this.filterEventTypeOptions.unshift({
          text: this.transLabel,
          value: ''
        });
      }
    });

    this.getSubscribableEventValues();

    this.checkPersonalEmailSubscriptionStatus(null);

    this.notificationSubScriptionService.getForwarderOptions().subscribe({
      next: result => {
        const forwarderByPermission = getForwarderByPermission(this.userProfile, this.permissionCode);
        const isAllNull = forwarderByPermission.every((x: any) => x == null);
        const forwarderOptionsByPermission = result.filter((x: any) => this.userProfile.userType === UserType.SuperAdmin.toString() ||
          isAllNull || forwarderByPermission.includes(x.value));

        console.log("this.userProfile = ", JSON.stringify(this.userProfile));
        console.log("forwarderByPermission = ", JSON.stringify(forwarderByPermission));
        console.log("isAllNull = ", isAllNull);
        console.log("forwarderOptionsByPermission = ", JSON.stringify(forwarderOptionsByPermission));

        this.forwarderOptions = deepCopy(forwarderOptionsByPermission);
        this.forwarderOptions.unshift({
          value: "ALL",
          text: "ALL - 全部"
        });

        this.filterForwarderOptions = deepCopy(forwarderOptionsByPermission);
        this.filterForwarderOptions.unshift({
          value: "",
          text: this.transLabel
        });

        this.forwarderOptionsForEdit = deepCopy(forwarderOptionsByPermission);
        this.forwarderOptionsForEdit.unshift({
          value: "ALL",
          text: "ALL - 全部"
        });

        this.orginForwarderOptions = deepCopy(this.forwarderOptions ?? []) as any[];
        this.orginForwarderOptionsForEdit = deepCopy(this.forwarderOptionsForEdit ?? []) as any[];
      }
    });

    this.notificationSubScriptionService.getTenantOptions().subscribe({
      next: (options: any[]) => {
        const tenantByPermission = getTenantByPermission(this.userProfile, this.permissionCode);
        const isAllNull = tenantByPermission.every((x: any) => x == null);
        const tenantOptionsByPermission = options.filter(x => this.userProfile.userType === UserType.SuperAdmin.toString() ||
          isAllNull || tenantByPermission.includes(x.tenantCode));

        this.tenantOptions = tenantOptionsByPermission.map(x => ({ tenantCode: x.tenantCode, tenantName: `${x.tenantCode} - ${x.tenantName}` }));
        this.tenantOptions.unshift({
          tenantCode: "ALL",
          tenantName: "ALL - 全部"
        });

        this.filterTenantOptions = tenantOptionsByPermission.map(x => ({ tenantCode: x.tenantCode, tenantName: `${x.tenantCode} - ${x.tenantName}` }));
        this.filterTenantOptions.unshift({
          tenantCode: "",
          tenantName: this.transLabel
        });

        this.tenantOptionsForEdit = tenantOptionsByPermission.map(x => ({ tenantCode: x.tenantCode, tenantName: `${x.tenantCode} - ${x.tenantName}` }));
        this.tenantOptionsForEdit.unshift({
          tenantCode: "ALL",
          tenantName: "ALL - 全部"
        });
      }
    });

    this.notificationSubScriptionService.getCustomerOptions().subscribe({
      next: result => {
        const customerByPermission = getCustomerByPermission(this.userProfile, this.permissionCode);
        const isAllNull = customerByPermission.every((x: any) => x == null);
        const customerOptionsByPermission = result.filter((x: any) => this.userProfile.userType === UserType.SuperAdmin.toString() ||
          isAllNull || customerByPermission.includes(x.customerCode));

        this.cutomerOptions = customerOptionsByPermission.map((x: any) => {
          return {
            label: `${x.customerCode} - ${x.customerName}`,
            value: x.customerCode
          };
        });
        this.cutomerOptions.unshift({
          value: "ALL",
          label: "ALL - 全部"
        });

        this.filterCutomerOptions = customerOptionsByPermission.map((x: any) => {
          return {
            label: `${x.customerCode} - ${x.customerName}`,
            value: x.customerCode
          };
        });
        this.filterCutomerOptions.unshift({
          value: "",
          label: this.transLabel
        });

        this.cutomerOptionsForEdit = customerOptionsByPermission.map((x: any) => {
          return {
            label: `${x.customerCode} - ${x.customerName}`,
            value: x.customerCode
          };
        });
        this.cutomerOptionsForEdit.unshift({
          value: "ALL",
          label: "ALL - 全部"
        });
      }
    });

    this.dropdownOptionsService.getFacilityOptions().subscribe({
      next: (options: any[]) => {
        const facilityByPermission = getFacilityByPermission(this.userProfile, this.permissionCode);
        const isAllNull = facilityByPermission.every((x: any) => x == null);
        const facilityOptionsByPermission = options.filter(x => this.userProfile.userType === UserType.SuperAdmin.toString() ||
          isAllNull || facilityByPermission.includes(x.optionCode));

        this.facilityOptions = (deepCopy(facilityOptionsByPermission) as any[]);
        this.facilityOptions.unshift({
          optionCode: "ALL",
          optionDesc: "ALL - 全部"
        });

        this.filterFacilityOptions = (deepCopy(facilityOptionsByPermission) as any[]);
        this.filterFacilityOptions.unshift({
          optionCode: "",
          optionDesc: this.transLabel
        });

        this.facilityOptionsForEdit = (deepCopy(facilityOptionsByPermission) as any[]);
        this.facilityOptionsForEdit.unshift({
          optionCode: "ALL",
          optionDesc: "ALL - 全部"
        });
      }
    });

    this.notificationSubScriptionService.getTenantOrgOptions().subscribe({
      next: (options: any[]) => {
        const orgIdByPermission = getOrgIdByPermission(this.userProfile, this.permissionCode);
        const isAllNull = orgIdByPermission.every((x: any) => x == null);
        const orgIdOptionsByPermission = options.filter(x => this.userProfile.userType === UserType.SuperAdmin.toString() ||
          isAllNull || orgIdByPermission.includes(x.orgId));

        this.orgIdOptions = (deepCopy(orgIdOptionsByPermission) as any[]);

        this.filterOrgIdOptions = this.orgIdOptions.map(x => ({ optionCode: x.orgId, optionDesc: `${x.orgId} - ${x.orgName}` }));
        this.filterOrgIdOptions.unshift({
          optionCode: "",
          optionDesc: this.transLabel
        });

        this.orgIdOptionsBySelectedTenant = this.orgIdOptions.map(x => ({ optionCode: x.orgId, optionDesc: `${x.orgId} - ${x.orgName}` }));
        this.orgIdOptionsBySelectedTenant.unshift({
          optionCode: "ALL",
          optionDesc: "ALL - 全部"
        });

        this.orgIdOptionsForEdit = this.orgIdOptions.map(x => ({ optionCode: x.orgId, optionDesc: `${x.orgId} - ${x.orgName}` }));
        this.orgIdOptionsForEdit.unshift({
          optionCode: "ALL",
          optionDesc: "ALL - 全部"
        });
      }
    });

    if (this.laasSetting.language == 'zh-tw') {
      this.fileTypeOptions = [
        {
          value: "Y",
          label: "Y - 合併檔案"
        },
        {
          value: "N",
          label: "N - 分割檔案"
        }
      ];

      this.isByOwnerOptions = [
        {
          value: true,
          label: "是"
        },
        {
          value: false,
          label: "否"
        }
      ];

    } else {
      this.isByOwnerOptions = [
        {
          value: true,
          label: "Yes"
        },
        {
          value: false,
          label: "No"
        }
      ];

      this.fileTypeOptions = [
        {
          value: "Y",
          label: "Y - combineFile"
        },
        {
          value: "N",
          label: "N - splitFile"
        }
      ];

    }
  }


  deleteConfirm(event: any, seqNo: number): void{
    this.translateService.get('SubscriptNotiSet.Confirm.ConfirmDelete')
    .subscribe({
      next: result => {
        this.confirmationService.confirm({
          target: event.target,
          message: result,
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
              //confirm action
              this.deleteNotifyEvent(seqNo);
          },
          reject: () => {
              //reject action
          }
      });
        return;
      }
    });
  }

  private deleteNotifyEvent(seqNo: number){
    this.loader.show();
    this.notificationSubScriptionService.deleteNotifyEvent(seqNo).subscribe({
      next: result => {
        this.translateService.get('SubscriptNotiSet.Success.DeleteSuccess')
        .subscribe({
          next: result => {
            this.loader.hide();
            this.toastService.success(result);
            return;
          }
        });
        this.searchNotifyEvent();
      },
      complete: () => {
        this.loader.hide();

      }
    });
  }

  deleteBtnClick(event: any, seqNo: number) {
    this.loader.show();
    this.notificationSubScriptionService.deleteNotifyEvent(seqNo).subscribe({
      next: result => {
        this.translateService.get('SubscriptNotiSet.Success.DeleteSuccess')
        .subscribe({
          next: result => {
            this.loader.hide();
            this.toastService.success(result);
            return;
          }
        });
        this.searchNotifyEvent();
      },
      complete: () => {
        this.loader.hide();

      }
    });
  }

  addBtnClick(event: any): void {
    this.loader.show();
    this.submitted = true;

    if (this.notifyForm.invalid) {
      this.loader.hide();
      return;
    }

    var addObject = {
      notifyEvents: this.selectedEventType,
      tenants: (this.selectedTenant.length == 0) ? ["ALL"] : this.selectedTenant,
      facilities: (this.selectedFacility.length == 0) ? ["ALL"] : this.selectedFacility,
      forwarders: (this.selectedForwarder.length == 0) ? ["ALL"] : this.selectedForwarder,
      customers: (this.selectedCustomer.length == 0) ? ["ALL"] : this.selectedCustomer,
      orgIds: (this.selectedOrgId.length == 0) ? ["ALL"] : this.selectedOrgId,
      subscriberId: this.subscriber,
      subscriberUserType: this.userProfile.userType,
      sendingMethod: 'Email',
      sendingTarget: this.email,
      isIncludeAttachment: 0,
      isByOwner: this.isByOwner ? 1 : 0,
      isDeletable: 1,
      isActivated: 1,
      isSwitchable: 1,
      fileType: this.selectedFileType
    };

    this.notificationSubScriptionService.addNotifyEvent(addObject).subscribe({
      next: result => {
        this.searchNotifyEvent();
        this.translateService.get('SubscriptNotiSet.Success.AddSuccess')
        .subscribe({
          next: result => {
            this.loader.hide();
            this.toastService.success(result);
            return;
          }
        });
        this.reset();

      },
      complete: () => {
        this.loader.hide();

      }
    });
  }

  searchBtnClick(event:any): void{
    this.searchNotifyEvent();
  }

  updateBtnClick(event: any): void {
    if (this.editObject.isChecked) {
      this.editObject.isActivated = 1;
    } else {
      this.editObject.isActivated = 0;
    }

    if (this.editObject.isCheckedByOwner) {
      this.editObject.isByOwner = 1;
    } else {
      this.editObject.isByOwner = 0;
    }

    this.editObject.orgId = this.orgIdOptionsForEdit.map(option => option.optionCode)
      .includes(this.editObject.orgId) ? this.editObject.orgId : "ALL"

    this.notificationSubScriptionService.updateNotifyEvent(this.editObject).subscribe({
      next: result => {
        this.searchNotifyEvent();
        this.translateService.get('SubscriptNotiSet.Success.UpdateSuccess')
        .subscribe({
          next: result => {
            this.toastService.success(result);
            return;
          }
        });
        this.isShowEditDialog = false;
      }
    });
  }

  editClick(event: any, item: any): void {
    this.isShowEditDialog = true;
    this.editObject = deepCopy(item);
    this.editObject.isChecked = (item.isActivated == 1);
    this.editObject.isCheckedByOwner = (item.isByOwner == 1);
    this.checkPersonalEmailSubscriptionStatusForEdit();
    this.checkOrgOptionsForEdit();
    this.filterForwarderOptionsForEdit(item);
  }

  filterForwarderOptionsForEdit(item: any) {
    const eventTypeText = item.notifyEventName;
    if (eventTypeText.includes('通知貨代已付款') || eventTypeText.includes('Notify forwarder payment')) {
      if(this.userProfile.userType == 'Forwarder'){
        const filterForwarderOptions = this.forwarderOptions.filter(option => option.value !== 'ALL');
        this.forwarderOptionsForEdit = filterForwarderOptions;
      }
    }else {
      this.forwarderOptionsForEdit = this.orginForwarderOptionsForEdit;
    }
  }

  reset() {
    this.selectedEventType = [];
    this.selectedTenant = [];
    this.selectedFacility = [];
    this.selectedForwarder = [];
    this.selectedCustomer = [];
    this.selectedOrgId = []
    this.isByOwner = false;
    this.submitted = false;
    this.isDisabledPersonalSubscription = true;
    this.selectedFileType = '';
  }

  searchNotifyEvent() {
    this.isLoading = true;
    this.formParam.language = this.laasSetting.language;
    this.formParam.consigneeKey = Array.isArray(this.formParam.consigneeKey) ? this.formParam.consigneeKey : [this.formParam.consigneeKey]
    this.formParam.subscriberId = Array.isArray(this.formParam.subscriberId) ? this.formParam.subscriberId : [this.formParam.subscriberId];

    this.notificationSubScriptionService.getUserSubscribe(this.formParam, this.subscriber, this.userType).subscribe({
      next: result => {

        this.subscribeResults = result;
      },
      complete: () => {
        this.isLoading = false;
        this.isOpenFilter = false;
      }
    })

  }

  translationLabel() {
    this.translateService.get('Common.Message.ChooseOption').subscribe((translated: string) =>{
      this.transLabel = this.translateService.instant('Common.Message.ChooseOption');
    });
  }

  // convenience getter for easy access to form fields
  get f() { return this.notifyForm.controls; }

  // If the event is not subscribable, then let the button disable.
  async checkPersonalEmailSubscriptionStatus(event: any) {
    this.isDisabledPersonalSubscription = true;
    if (this.selectedEventType.length != 0) {
      this.isDisabledPersonalSubscription = false;
      let isSubscribable: boolean = this.selectedEventType.every(value => this.subscribableEventValues.includes(value));
      if (!isSubscribable) {
        this.isDisabledPersonalSubscription = true;
        this.isByOwner = false;
      }
    } else {
      this.isByOwner = false;
    }

    if (event != null) {
      const eventPermissionRequest = {
        eventSeqNoList: event.value
      }

      this.notificationSubScriptionService.getEventPermission(eventPermissionRequest, this.laasSetting.language).subscribe({
        next: result => {

        if (result.showForwarder) {
          this.isShowForwarder = true;
        } else {
          this.isShowForwarder = false;
          this.selectedForwarder = [];
        }

        if (result.showCustomer) {
          this.isShowCustomer = true;
        } else {
          this.isShowCustomer = false;
          this.selectedCustomer = [];
        }

        if (result.showFacility) {
          this.isShowFacility = true;
        } else {
          this.isShowFacility = false;
          this.selectedFacility = [];
        }

        if (result.showOrgId) {
          this.isShowOrgId = true;
        } else {
          this.isShowOrgId = false;
          this.selectedOrgId = [];
        }

        if (result.showTenant) {
          this.isShowTenant = true;
        } else {
          this.isShowTenant = false;
          this.selectedTenant = [];
        }

        if (result.showAttachFile) {
          this.isShowAttachFile = true;
        } else {
          this.isShowAttachFile = false;
          this.selectedFileType = ''
        }
      }
      });
      const eventTypeOptions = this.eventTypeOptions.filter((x: any) => this.selectedEventType.includes(x.value));
      const eventTypeText = eventTypeOptions.map((x: any) => x.text).join(',');

      if (eventTypeText.includes('通知貨代已付款') || eventTypeText.includes('Notify forwarder payment')) {
        if(this.userProfile.userType == 'Forwarder'){
          const filterForwarderOptions = this.forwarderOptions.filter(option => option.value !== 'ALL');
          this.forwarderOptions = filterForwarderOptions;
          this.forwarderOptionsForEdit = filterForwarderOptions;
          this.selectedForwarder = filterForwarderOptions.map((x: any) => x.value);
          this.isForwarderDisabled = true;
        }

      }else {
        this.forwarderOptions = this.orginForwarderOptions;
        this.forwarderOptionsForEdit = this.orginForwarderOptionsForEdit;
        this.selectedForwarder = [];
        this.isForwarderDisabled = false;
      }

    }
  };

  getSubscribableEventValues() {
    this.notificationSubScriptionService.getSubscribableEventValues().subscribe({
      next: (result: string[]) => {
        this.subscribableEventValues = result.map(obj => Object.values(obj)[0]);
      }
    });
  }

  // If the event is not subscribable, then let the button disable.
  checkPersonalEmailSubscriptionStatusForEdit() {
    this.isDisabledPersonalSubscriptionForEdit = false;
    let isSubscribable = this.subscribableEventValues.includes(this.editObject.notifyEventSeqNo);
    if (!isSubscribable) {
      this.isDisabledPersonalSubscriptionForEdit = true;
      this.editObject.isCheckedByOwner = false;
    }


    if (this.editObject.notifyEventSeqNo != null) {
      const eventPermissionRequest = {
        eventSeqNoList: [this.editObject.notifyEventSeqNo]
      }

      this.notificationSubScriptionService.getEventPermission(eventPermissionRequest, this.laasSetting.language).subscribe({
        next: result => {

        if (result.showForwarder) {
          this.editIsShowForwarder = true;
        } else {
          this.editIsShowForwarder = false;
        }

        if (result.showCustomer) {
          this.editIsShowCustomer = true;
        } else {
          this.editIsShowCustomer = false;
        }

        if (result.showFacility) {
          this.editIsShowFacility = true;
        } else {
          this.editIsShowFacility = false;
        }

        if (result.showOrgId) {
          this.editIsShowOrgId = true;
        } else {
          this.editIsShowOrgId = false;
        }

        if (result.showTenant) {
          this.editIsShowTenant = true;
        } else {
          this.editIsShowTenant = false;
        }

        if (result.showAttachFile) {
          this.editIsShowAttachFile = true;
        } else {
          this.editIsShowAttachFile = false;
          this.editObject.selectedFileType = undefined
        }
      }
      });
    }
  };

  getOrgOptions(event: any) {
    let selectedTenantCodes = event.value;
    let showAll = selectedTenantCodes.length == 0 || selectedTenantCodes.includes("ALL");
    this.orgIdOptionsBySelectedTenant = this.filterOrgOptions(selectedTenantCodes, showAll);
    this.selectedOrgId = this.selectedOrgId.filter(orgId => {
      return this.orgIdOptionsBySelectedTenant.map(option => option.optionCode).includes(orgId) || showAll;
    });
    this.orgIdOptionsBySelectedTenant.unshift({
      optionCode: "ALL",
      optionDesc: "ALL - 全部"
    });
  }

  getOrgOptionsForEdit(event: any) {
    let selectedTenantCode = event.value;
    let showAll = selectedTenantCode.includes("ALL");
    this.orgIdOptionsForEdit = this.filterOrgOptions(selectedTenantCode, showAll);
    this.orgIdOptionsForEdit.unshift({
      optionCode: "ALL",
      optionDesc: "ALL - 全部"
    });
  }

  checkOrgOptionsForEdit() {
    let selectedTenantCode = this.editObject.tenantCode;
    let showAll = selectedTenantCode.includes("ALL");
    this.orgIdOptionsForEdit = this.filterOrgOptions(selectedTenantCode, showAll);
    this.orgIdOptionsForEdit.unshift({
      optionCode: "ALL",
      optionDesc: "ALL - 全部"
    });
  }

  filterOrgOptions(selectedTenantCode: any, showAll: boolean): any[] {
    return this.orgIdOptions.filter(option => {
      return selectedTenantCode.includes(option.tenantCode) || showAll;
    }).map(option => ({ optionCode: option.orgId, optionDesc: `${option.orgId} - ${option.orgName}` }));
  }

}
